import { useParams } from "react-router";
import { ModelEditor } from "./model-editor";

export default function FinancialSituationModelDetailPage() {
  const { id } = useParams<{ id: string }>();
  return <ModelEditor id={id!} />;
}
